

export function master() {
    console.log('Entramos en js de ebanxs');
}
export function submitEbanxForm() {
    $("#pay-button").hide();
    $("#tech-general-error-ebanxs").html("");
    tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', true);
    $.ajax({
        url: '/PaymentToken/confirmEbanxs',
        type: 'Post',
        data: getElementsEbanxs(JSON.parse($("#preOrderData").val()).order),
        success: function (response) {
            console.log("" + response.response + "");
            if (response.response == "SUCCESS") {
                console.log("Se realizo el pago de manera correcta, mandamos a submitEnrollmentForm() ");
                $("#tech-general-error-ebanxs").html("");
                tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
                tech.newEnrollment.submitEnrollmentForm();
            } else {
                tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
                console.log("Error encontrado: " + response.response + "");
                $("#tech-general-error-ebanxs").html(response.response);
                $("#pay-button").show();
            }
        },
        error: function (errorThrown) {
            console.log("" + errorThrown.responseText + "");
        }
    });
}
function getElementsEbanxs(elements) {
    let plazosEbanx = $('#input-plazos').val();
    let precioEbanx = (plazosEbanx == 1) ? elements.precio : JSON.parse($("#priceInfo").val()).InitialQuotaPrice;
    return {
        Name: elements.nombreApellidos,
        OrderNumber: elements.numPedido,
        Country: $("#countryCode").val(),
        CardNumber: $("#enrollment-card-number-input").val(),
        CardCvv: $("#enrollment-card-cvv-input").val(),
        CardDueDate: $("#enrollment-card-expiry-input").val(),
        Amount: precioEbanx,
        Email: elements.email,
        Document: elements.nif,
        PhoneNumber: $("#enrollment-phone-input").val(),
        CurrencyCode: $("#currencyCode").val(),
        IdPaymentTlmk: 0,
        Plazos: plazosEbanx
    }

}
